import { twJoin } from 'tailwind-merge'

export const CONTENT_HORIZONTAL_PADDING_CLASSNAME = 'px-4 tablet:px-6 desktop:px-14'

// pulls a horizontally scrolling block out to the screen edge through the content padding above
export const CONTENT_HORIZONTAL_BLEED_CLASSNAME = '-mx-4 tablet:-mx-6 desktop:-mx-14'

/** The centred frame the navbar and the page content share. */
export const CONTENT_FRAME_CLASSNAME = 'mx-auto w-full max-w-400'

export const CONTENT_CLASSNAME = twJoin(
  CONTENT_HORIZONTAL_PADDING_CLASSNAME,
  CONTENT_FRAME_CLASSNAME,
)

export const DASHBOARD_LAYOUT_CLASSNAME =
  'bg-bg-page text-base text-text-primary relative font-normal relative font-inter'
